;
export const localeMessage = {
  en: {
    globalName: `Global Name EN`,
    globalStatus_all: `All`,
    globalStatus_process: `In Process`,
    globalStatus_live: `Live`,
    globalStatus_sold_out: `Sold Out`,
    globalStatus_banned: `Banned`,
    globalStatus_disabled: `Disabled`,
    globalStatus_draft: `Draft`,
    globalStatus_delete: `Deleted`,
    globalStatus_update_failed: `Publish Failed`,
    globalStatus_unpublished: `Unpublished`,
    globalTaskWait: `Processing,Please wait`,
    globalTaskSuccess: `Operation Success`,
    globalTaskFailed: `Some orders process failed, please try again later`,
    globalTaskSuccessNumber: `Success`,
    globalTaskTotalNumber: `Total`,
    globalTaskFailedNumber: `Failed`,
    globalTaskResult: `Result`,
    globalAction: `Action`,
    globalNoPermission: `Your account does not have this permission, please contact store administrator to ask or upgrade`,
    globalNoEmptyText: `No Data`,
    globalsSearch: `Search`,
    globalsReset: `Reset`,
    globalsTotalPage: `Total { total }`,
    globalsNoName: `No name`,
    globalsSeeMoreExpand: `View more`,
    globalsSeeMoreRetract: `View less`,
    globalsSeeMore: `See { more } Items`,
    globalsNoProductYet: `No product yet`,
    globalsSyncSuccess: `Sync completed`,
    globalsSync: `Sync`,
    globalsSynchronizing: `Syncing`,
    globalsSyncError: `Sync failed`,
    globalsOperationGuide: `Operation guide`,
    globalsIsRequired: `This field is required`,
    globalsPleaseSelect: `Please Select`,
    globalsNotification: `Notification`,
    globalsBrowserBlockedInfo: `It is detected that the new pop-up window has been blocked by the browser, please click "Continue" to open a new page window (you can also search for "Remove Browser Blocking Method/ Cara " in the Help Center to unblock it)`,
    globalsGoContinue: `Continue`,
    isRequired: `This field is required`,
    globalsContactUsPackage: `Please contact us for package information and quotation`,
    globalsContactNow: `Contact Now`,
    globalsLater: `Later`,
    globalsPackageExpired: `Your package has expired`,
    globalsExportStatus: `Status`,
    globalsExportINProcess: `Processing`,
    globalsExportFinished: `Active`,
    globalsExportFailed: `Download failed`,
    globalsExportDisabled: `Expired`,
    globalsYesterday: `Yesterday`,
    globalsWeekly: `Weekly`,
    globalsMonthly: `Monthly`,
    globalsYearly: `Yearly`,
    globalPleaseEnter: `Please Enter`,
    globalPleaseSelect: `Please Select`,
    globalNoData: `No Data`
  },
  zh: {
    globalName: `Global Name ZH`,
    globalStatus_all: `\u5168\u90E8`,
    globalStatus_process: `\u53D1\u5E03\u4E2D`,
    globalStatus_live: `\u5DF2\u4E0A\u67B6`,
    globalStatus_sold_out: `\u5DF2\u552E\u5B8C`,
    globalStatus_banned: `\u5DF2\u7981\u5356`,
    globalStatus_disabled: `\u5DF2\u4E0B\u67B6`,
    globalStatus_draft: `\u8349\u7A3F`,
    globalStatus_delete: `\u5DF2\u5220\u9664`,
    globalStatus_update_failed: `\u53D1\u5E03\u5931\u8D25`,
    globalStatus_unpublished: `\u672A\u53D1\u5E03`,
    globalTaskWait: `\u5904\u7406\u4E2D\uFF0C\u8BF7\u7A0D\u5019`,
    globalTaskSuccess: `\u64CD\u4F5C\u6210\u529F`,
    globalTaskFailed: `\u5904\u7406\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5`,
    globalTaskSuccessNumber: `\u6210\u529F`,
    globalTaskTotalNumber: `\u5168\u90E8`,
    globalTaskFailedNumber: `\u5931\u8D25`,
    globalTaskResult: `\u7ED3\u679C`,
    globalAction: `\u64CD\u4F5C`,
    globalNoPermission: `\u60A8\u7684\u8D26\u6237\u6CA1\u6709\u6B64\u6743\u9650\uFF0C\u5982\u6709\u95EE\u9898\u8BF7\u8054\u7CFB\u5E97\u94FA\u9AD8\u7EA7\u7BA1\u7406\u5458\u5347\u7EA7\uFF1B`,
    globalNoEmptyText: `\u6682\u65E0\u6570\u636E`,
    globalsSearch: `\u641C\u7D22`,
    globalsReset: `\u6E05\u7A7A`,
    globalsTotalPage: `\u603B\u5171{ total }\u6761\u6570\u636E`,
    globalsNoName: `\u540D\u79F0\u4E3A\u7A7A`,
    globalsSeeMoreExpand: `\u67E5\u770B\u66F4\u591A`,
    globalsSeeMoreRetract: `\u6536\u8D77`,
    globalsSeeMore: `\u67E5\u770B{ more }\u4E2A\u4EE5\u4E0A\u7684\u53D8\u5316`,
    globalsNoProductYet: `\u672A\u6DFB\u52A0\u5546\u54C1`,
    globalsSyncSuccess: `\u540C\u6B65\u5B8C\u6210`,
    globalsSync: `\u540C\u6B65`,
    globalsSynchronizing: `\u540C\u6B65\u4E2D`,
    globalsSyncError: `\u540C\u6B65\u5931\u8D25`,
    globalsOperationGuide: `\u64CD\u4F5C\u5F15\u5BFC`,
    globalsIsRequired: `\u5FC5\u586B\u9879`,
    globalsPleaseSelect: `\u8BF7\u9009\u62E9`,
    globalsNotification: `\u63D0\u793A`,
    globalsBrowserBlockedInfo: `\u68C0\u6D4B\u5230\u65B0\u7A97\u53E3\u5DF2\u88AB\u6D4F\u89C8\u5668\u62E6\u622A\uFF0C\u8BF7\u70B9\u51FB\u201C\u7EE7\u7EED\u524D\u5F80\u201D\u6253\u5F00\u65B0\u9875\u9762\u7A97\u53E3\uFF08\u60A8\u8FD8\u80FD\u5728\u5E2E\u52A9\u4E2D\u5FC3\u641C\u7D22\u201C\u89E3\u9664\u6D4F\u89C8\u5668\u62E6\u622A\u65B9\u6CD5\u201D \u6765\u89E3\u9664\u62E6\u622A\uFF09`,
    globalsGoContinue: `\u7EE7\u7EED\u524D\u5F80`,
    isRequired: `\u5FC5\u586B\u9879`,
    globalsContactUsPackage: `\u8BF7\u8054\u7CFB\u6211\u4EEC\u83B7\u53D6\u5957\u9910\u4FE1\u606F\u548C\u62A5\u4EF7`,
    globalsContactNow: `\u9A6C\u4E0A\u8054\u7CFB`,
    globalsLater: `\u7A0D\u540E`,
    globalsPackageExpired: `\u60A8\u7684\u5957\u9910\u5DF2\u8FC7\u671F`,
    globalsExportStatus: `\u72B6\u6001`,
    globalsExportINProcess: `\u8FDB\u884C\u4E2D`,
    globalsExportFinished: `\u6709\u6548`,
    globalsExportFailed: `\u4E0B\u8F7D\u5931\u8D25`,
    globalsExportDisabled: `\u5DF2\u5931\u6548`,
    globalsYesterday: `\u6628\u5929`,
    globalsWeekly: `\u8FD17\u5929`,
    globalsMonthly: `\u8FD11\u4E2A\u6708`,
    globalsYearly: `\u8FD11\u5E74`,
    globalPleaseEnter: `\u8BF7\u8F93\u5165`,
    globalPleaseSelect: `\u8BF7\u9009\u62E9`,
    globalNoData: `\u65E0\u6570\u636E`
  },
  id: {
    globalName: `Global Name ID`,
    globalStatus_all: `Semua`,
    globalStatus_process: `Sedang diproses`,
    globalStatus_live: `Aktif`,
    globalStatus_sold_out: `Habis`,
    globalStatus_banned: `Dilarang`,
    globalStatus_disabled: `Nonaktif`,
    globalStatus_draft: `Draft`,
    globalStatus_delete: `Dihapus`,
    globalStatus_update_failed: `Gagal Ditampilkan`,
    globalStatus_unpublished: `Tidak diterbitkan`,
    globalTaskWait: `Sedang Diproses,Silahkan Tunggu`,
    globalTaskSuccess: `Pengaturan Berhasil`,
    globalTaskFailed: `Beberapa pesanan gagal diproses, coba lagi nanti`,
    globalTaskSuccessNumber: `Sukses`,
    globalTaskTotalNumber: `Total`,
    globalTaskFailedNumber: `Gagal`,
    globalTaskResult: `Hasil`,
    globalAction: `Atur`,
    globalNoPermission: `Akun Anda tidak memiliki izin ini, silakan hubungi administrator Toko untuk bertanya atau upgrade`,
    globalNoEmptyText: `Tidak ada data`,
    globalsSearch: `Cari`,
    globalsReset: `Reset`,
    globalsTotalPage: `Total { total }`,
    globalsNoName: `Tidak memiliki nama`,
    globalsSeeMoreExpand: `lihat lebih banyak`,
    globalsSeeMoreRetract: `lihat lebih singkat`,
    globalsSeeMore: `Lihat { more } produk lagi`,
    globalsNoProductYet: `Belum ada produk`,
    globalsSyncSuccess: `Sinkronisasi Berhasil`,
    globalsSync: `Sinkronkan`,
    globalsSynchronizing: `Sedang Sinkronisasi`,
    globalsSyncError: `Sinkronisasi Gagal`,
    globalsOperationGuide: `Tips pengoperasian`,
    globalsIsRequired: `Harus diisi`,
    globalsPleaseSelect: `Silahkan Pilih`,
    globalsNotification: `Notifikasi`,
    globalsBrowserBlockedInfo: `Terdeteksi bahwa jendela pop-up Anda di blok oleh browser, silakan klik "Lanjutkan" untuk membuka jendela pop-up Anda (Anda juga dapat mencari "Cara Mengatasi Masalah Halaman Diblok di Browser Anda" di Pusat Bantuan untuk mengatasinya)`,
    globalsGoContinue: `Lanjutkan`,
    isRequired: `Harus diisi`,
    globalsContactUsPackage: `Silakan hubungi kami untuk Informasi Paket dan penawaran`,
    globalsContactNow: `Hubungi Sekarang`,
    globalsLater: `Lain Kali`,
    globalsPackageExpired: `Paket Anda telah kedaluwarsa`,
    globalsExportStatus: `Status`,
    globalsExportINProcess: `Diproses`,
    globalsExportFinished: `Aktif`,
    globalsExportFailed: `Download Gagal`,
    globalsExportDisabled: `Kedaluwarsa`,
    globalsYesterday: `Kemarin`,
    globalsWeekly: `Mingguan`,
    globalsMonthly: `Bulanan`,
    globalsYearly: `Tahunan`,
    globalPleaseEnter: `Masukkan`,
    globalPleaseSelect: `Silahkan Pilih`,
    globalNoData: `Tidak Ada Data`
  },
  th: {
    globalName: `Global Name ZH`,
    globalStatus_all: `\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    globalStatus_process: `\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48`,
    globalStatus_live: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E25\u0E49\u0E27`,
    globalStatus_sold_out: `\u0E02\u0E32\u0E22\u0E2B\u0E21\u0E14`,
    globalStatus_banned: `\u0E2B\u0E49\u0E32\u0E21\u0E02\u0E32\u0E22`,
    globalStatus_disabled: `\u0E40\u0E25\u0E34\u0E01\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22`,
    globalStatus_draft: `\u0E09\u0E1A\u0E31\u0E1A\u0E23\u0E48\u0E32\u0E07`,
    globalStatus_delete: `\u0E25\u0E1A\u0E41\u0E25\u0E49\u0E27`,
    globalStatus_update_failed: `\u0E40\u0E1C\u0E1A\u0E41\u0E1E\u0E23\u0E48\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    globalStatus_unpublished: `\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E1E\u0E31\u0E1A\u0E25\u0E34\u0E0A`,
    globalTaskWait: `\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E2D\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48`,
    globalTaskSuccess: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    globalTaskFailed: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07`,
    globalTaskSuccessNumber: `\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    globalTaskTotalNumber: `\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    globalTaskFailedNumber: `\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    globalTaskResult: `\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C`,
    globalAction: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    globalNoPermission: `\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E14\u0E39\u0E41\u0E25\u0E23\u0E30\u0E1A\u0E1A\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E16\u0E32\u0E21\u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E31\u0E1B\u0E40\u0E01\u0E23\u0E14`,
    globalNoEmptyText: `\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25`,
    globalsSearch: `\u0E04\u0E49\u0E19\u0E2B\u0E32`,
    globalsReset: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E43\u0E2B\u0E21\u0E48`,
    globalsTotalPage: `\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14{ total }`,
    globalsNoName: `\u0E44\u0E21\u0E48\u0E21\u0E35\u0E0A\u0E37\u0E48\u0E2D`,
    globalsSeeMoreExpand: `\u0E14\u0E39\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21`,
    globalsSeeMoreRetract: `\u0E22\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32`,
    globalsSeeMore: `\u0E14\u0E39{ more }\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19`,
    globalsNoProductYet: `\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    globalsSyncSuccess: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    globalsSync: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D`,
    globalsSynchronizing: `\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D`,
    globalsSyncError: `\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    globalsOperationGuide: `\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19`,
    globalsIsRequired: `\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E23\u0E2D\u0E01`,
    globalsPleaseSelect: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01`,
    globalsNotification: `\u0E04\u0E33\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19`,
    globalsBrowserBlockedInfo: `\u0E15\u0E23\u0E27\u0E08\u0E1E\u0E1A\u0E27\u0E48\u0E32\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E1B\u0E4A\u0E2D\u0E1B\u0E2D\u0E31\u0E1B\u0E43\u0E2B\u0E21\u0E48\u0E16\u0E39\u0E01\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E42\u0E14\u0E22\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01 "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E34\u0E14\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E43\u0E2B\u0E21\u0E48 (\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E49\u0E19\u0E2B\u0E32 "Remove Browser Blocking Method/ Cara " \u0E43\u0E19\u0E28\u0E39\u0E19\u0E22\u0E4C\u0E0A\u0E48\u0E27\u0E22\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E25\u0E14\u0E1A\u0E25\u0E47\u0E2D\u0E01\u0E44\u0E14\u0E49)`,
    globalsGoContinue: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D`,
    isRequired: `\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E23\u0E2D\u0E01`,
    globalsContactUsPackage: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E40\u0E23\u0E32\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E41\u0E25\u0E30\u0E43\u0E1A\u0E40\u0E2A\u0E19\u0E2D\u0E23\u0E32\u0E04\u0E32`,
    globalsContactNow: `\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D\u0E17\u0E31\u0E19\u0E17\u0E35`,
    globalsLater: `\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07`,
    globalsPackageExpired: `\u0E41\u0E1E\u0E47\u0E04\u0E40\u0E01\u0E08\u0E04\u0E38\u0E13\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38\u0E41\u0E25\u0E49\u0E27`,
    globalsExportStatus: `\u0E2A\u0E16\u0E32\u0E19\u0E30`,
    globalsExportINProcess: `\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    globalsExportFinished: `\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07`,
    globalsExportFailed: `\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    globalsExportDisabled: `\u0E2B\u0E21\u0E14\u0E2D\u0E32\u0E22\u0E38\u0E41\u0E25\u0E49\u0E27`,
    globalsYesterday: `\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19`,
    globalsWeekly: `\u0E23\u0E32\u0E22\u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C`,
    globalsMonthly: `\u0E23\u0E32\u0E22 1 \u0E40\u0E14\u0E37\u0E2D\u0E19`,
    globalsYearly: `\u0E23\u0E32\u0E22\u0E1B\u0E35`,
    globalPleaseEnter: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01`,
    globalPleaseSelect: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01`,
    globalNoData: `\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25`
  },
  vn: {
    globalName: `Global Name VN`,
    globalStatus_all: `T\u1EA5t c\u1EA3`,
    globalStatus_process: `\u0110ang x\u1EED l\xFD`,
    globalStatus_live: `Ho\u1EA1t \u0111\u1ED9ng`,
    globalStatus_sold_out: `\u0110\xE3 b\xE1n h\u1EBFt`,
    globalStatus_banned: `\u0110\xE3 c\u1EA5m b\xE1n`,
    globalStatus_disabled: `\u0110\xE3 h\u1EE7y b\u1ECF`,
    globalStatus_draft: `B\u1EA3n nh\xE1p`,
    globalStatus_delete: `\u0110\xE3 x\xF3a`,
    globalStatus_update_failed: `\u0110\u0103ng Th\u1EA5t b\u1EA1i`,
    globalStatus_unpublished: `Ch\u01B0a \u0110\u0103ng`,
    globalTaskWait: `\u0110ang x\u1EED l\xFD, vui l\xF2ng \u0111\u1EE3i`,
    globalTaskSuccess: `Thao t\xE1c th\xE0nh c\xF4ng`,
    globalTaskFailed: `M\u1ED9t s\u1ED1 \u0111\u01A1n h\xE0ng x\u1EED l\xFD th\u1EA5t b\u1EA1i, vui l\xF2ng th\u1EED l\u1EA1i sau`,
    globalTaskSuccessNumber: `Th\xE0nh c\xF4ng`,
    globalTaskTotalNumber: `T\u1ED5ng`,
    globalTaskFailedNumber: `Th\u1EA5t b\u1EA1i`,
    globalTaskResult: `K\u1EBFt qu\u1EA3`,
    globalAction: `Thao t\xE1c`,
    globalNoPermission: `T\xE0i kho\u1EA3n c\u1EE7a b\u1EA1n kh\xF4ng c\xF3 quy\u1EC1n truy c\u1EADp, vui l\xF2ng li\xEAn h\u1EC7 v\u1EDBi qu\u1EA3n tr\u1ECB vi\xEAn c\u1EEDa h\xE0ng \u0111\u1EC3 y\xEAu c\u1EA7u ho\u1EB7c n\xE2ng c\u1EA5p`,
    globalNoEmptyText: `Kh\xF4ng c\xF3 D\u1EEF li\u1EC7u`,
    globalsSearch: `T\xECm ki\u1EBFm`,
    globalsReset: `\u0110\u1EB7t l\u1EA1i`,
    globalsTotalPage: `T\u1ED5ng { total }`,
    globalsNoName: `Kh\xF4ng t\xEAn`,
    globalsSeeMoreExpand: `Xem th\xEAm`,
    globalsSeeMoreRetract: `Thu g\u1ECDn`,
    globalsSeeMore: `Xem { more } s\u1EA3n ph\u1EA9m`,
    globalsNoProductYet: `Ch\u01B0a c\xF3 s\u1EA3n ph\u1EA9m`,
    globalsSyncSuccess: `Ho\xE0n th\xE0nh \u0110\u1ED3ng b\u1ED9`,
    globalsSync: `\u0110\u1ED3ng b\u1ED9`,
    globalsSynchronizing: `\u0110ang \u0111\u1ED3ng b\u1ED9`,
    globalsSyncError: `\u0110\u1ED3ng b\u1ED9 Th\u1EA5t b\u1EA1i`,
    globalsOperationGuide: `H\u01B0\u1EDBng d\u1EABn thao t\xE1c`,
    globalsIsRequired: `D\xF2ng n\xE0y l\xE0 b\u1EAFt bu\u1ED9c`,
    globalsPleaseSelect: `Vui l\xF2ng Ch\u1ECDn`,
    globalsNotification: `Th\xF4ng b\xE1o`,
    globalsBrowserBlockedInfo: `Ph\xE1t hi\u1EC7n c\u1EEDa s\u1ED5 b\u1EADt l\xEAn m\u1EDBi \u0111\xE3 b\u1ECB tr\xECnh duy\u1EC7t ch\u1EB7n, vui l\xF2ng nh\u1EA5p v\xE0o "Ti\u1EBFp t\u1EE5c" \u0111\u1EC3 m\u1EDF c\u1EEDa s\u1ED5 trang m\u1EDBi (b\u1EA1n c\u0169ng c\xF3 th\u1EC3 t\xECm ki\u1EBFm "Ph\u01B0\u01A1ng ph\xE1p X\xF3a ch\u1EB7n tr\xECnh duy\u1EC7t" trong Trung t\xE2m tr\u1EE3 gi\xFAp \u0111\u1EC3 b\u1ECF ch\u1EB7n)`,
    globalsGoContinue: `Ti\u1EBFp t\u1EE5c`,
    isRequired: `D\xF2ng n\xE0y l\xE0 b\u1EAFt bu\u1ED9c`,
    globalsContactUsPackage: `Vui l\xF2ng li\xEAn h\u1EC7 v\u1EDBi ch\xFAng t\xF4i \u0111\u1EC3 bi\u1EBFt th\xF4ng tin v\xE0 b\xE1o gi\xE1 g\xF3i`,
    globalsContactNow: `Li\xEAn h\u1EC7 ngay`,
    globalsLater: `\u0110\u1EC3 sau`,
    globalsPackageExpired: `G\xF3i c\u1EE7a b\u1EA1n \u0111\xE3 h\u1EBFt h\u1EA1n`,
    globalsExportStatus: `Tr\u1EA1ng th\xE1i`,
    globalsExportINProcess: `\u0110ang x\u1EED l\xFD`,
    globalsExportFinished: `Ho\u1EA1t \u0111\u1ED9ng`,
    globalsExportFailed: `T\u1EA3i xu\u1ED1ng th\u1EA5t b\u1EA1i`,
    globalsExportDisabled: `H\u1EBFt h\u1EA1n`,
    globalsYesterday: `H\xF4m qua`,
    globalsWeekly: `H\xE0ng tu\u1EA7n`,
    globalsMonthly: `H\xE0ng th\xE1ng`,
    globalsYearly: `H\xE0ng n\u0103m`,
    globalPleaseEnter: `Vui l\xF2ng Nh\u1EADp`,
    globalPleaseSelect: `Vui l\xF2ng Ch\u1ECDn`,
    globalNoData: `Kh\xF4ng c\xF3 D\u1EEF li\u1EC7u`
  }
};
